import React from 'react'
import copy from 'copy-to-clipboard'

const handleClick = (copyText: string) => {
  copy(copyText.toString(), { format: 'text/plain' })
}

const handleKeyPress = (
  e: React.KeyboardEvent<HTMLElement>,
  copyText: string
) => {
  if (e.key === 'Enter') {
    handleClick(copyText)
  }
}

// eslint-disable-next-line import/prefer-default-export
export const CopyId = ({ copyText }: { copyText: string }) => (
  <i
    className="far fa-copy"
    title={copyText}
    role="button"
    tabIndex={0}
    onClick={() => handleClick(copyText)}
    onKeyPress={(e) => handleKeyPress(e, copyText)}
    data-testid="CopyId"
  />
)
